<template>
  <PdfChapterTemplate
    page-title="《中国新闻传播学年鉴》"
    section-label="传播平台"
    :section-route="sectionRoute"
    pager-aria-label="页码切换"
    layout-xml-path="/pdf/zhongguoxinwenchuanboxuenianjian/layout.xml"
    :crop="crop"
    :pages="pages"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
  />
</template>

<script>
import PdfChapterTemplate from '@/components/PdfChapterTemplate.vue';

export default {
  name: 'Lanhuzhongguoxinwenchuanboxuenianjian',
  components: {
    PdfChapterTemplate
  },
  data() {
    return {
      sectionRoute: '/lanhu_chuanboyupingtai',
      crop: {
        left: 76,
        right: 76,
        top: 150,
        bottom: 98
      },
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      pages: [
        { pdfPage: 66, src: require('./assets/page-svg/page-066.jpg') },
        { pdfPage: 67, src: require('./assets/page-svg/page-067.jpg') }
      ]
    };
  }
};
</script>
